var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg777(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "777 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect218",
    d: "M75.3461 25.6975H29.216V71.8275H75.3461V25.6975Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect220",
    d: "M141.134 25.6964H95.0036V71.8286H141.134V25.6964Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect222",
    d: "M75.3461 92.7195H29.216V138.851H75.3461V92.7195Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect224",
    d: "M141.134 92.7195H95.0036V138.852H141.134V92.7195Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect226",
    d: "M207.132 25.8985H161.005V72.0296H207.132V25.8985Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect228",
    d: "M272.92 25.8996H226.789V72.0306H272.92V25.8996Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect230",
    d: "M207.132 92.9226H161.005V139.052H207.132V92.9226Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect232",
    d: "M272.92 92.9226H226.789V139.054H272.92V92.9226Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect234",
    d: "M75.3461 159.944H29.216V206.077H75.3461V159.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect236",
    d: "M141.134 159.944H95.0036V206.077H141.134V159.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect238",
    d: "M75.3461 226.965H29.216V273.097H75.3461V226.965Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect240",
    d: "M141.134 226.969H95.0036V273.097H141.134V226.969Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect242",
    d: "M207.132 159.944H161.005V206.075H207.132V159.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect244",
    d: "M272.92 159.944H226.789V206.077H272.92V159.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect246",
    d: "M207.132 226.965H161.005V273.097H207.132V226.965Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect248",
    d: "M272.92 226.969H226.789V273.097H272.92V226.969Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect250",
    d: "M338.709 25.8996H292.579V72.0306H338.709V25.8996Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect252",
    d: "M338.709 92.9226H292.579V139.054H338.709V92.9226Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect254",
    d: "M338.709 159.944H292.579V206.077H338.709V159.944Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect256",
    d: "M338.709 226.969H292.579V273.097H338.709V226.969Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect258",
    d: "M75.4518 293.992H29.3217V340.12H75.4518V293.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect260",
    d: "M141.239 293.992H95.1093V340.12H141.239V293.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect262",
    d: "M207.24 293.992H161.112V340.12H207.24V293.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect264",
    d: "M273.029 293.992H226.895V340.12H273.029V293.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect266",
    d: "M338.817 293.992H292.685V340.12H338.817V293.992Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect268",
    d: "M404.6 25.8975H358.47V72.0286H404.6V25.8975Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect270",
    d: "M404.6 92.9205H358.47V139.052H404.6V92.9205Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect272",
    d: "M404.6 159.943H358.47V206.075H404.6V159.943Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect274",
    d: "M404.6 226.966H358.47V273.095H404.6V226.966Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect276",
    d: "M470.388 25.8975H424.258V72.0286H470.388V25.8975Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect278",
    d: "M470.388 92.9205H424.258V139.052H470.388V92.9205Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect280",
    d: "M470.388 159.943H424.258V206.075H470.388V159.943Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect282",
    d: "M470.388 226.966H424.258V273.095H470.388V226.966Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect284",
    d: "M404.709 293.99H358.577V340.118H404.709V293.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect286",
    d: "M470.495 293.99H424.365V340.118H470.495V293.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect288",
    d: "M75.4539 361.013H29.3217V407.145H75.4539V361.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect290",
    d: "M141.24 361.015H95.1104V407.145H141.24V361.015Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect292",
    d: "M207.24 361.013H161.112V407.145H207.24V361.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect294",
    d: "M273.027 361.015H226.897V407.145H273.027V361.015Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect296",
    d: "M338.813 361.015H292.685V407.145H338.813V361.015Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect298",
    d: "M75.5596 428.039H29.4275V474.169H75.5596V428.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect300",
    d: "M141.347 428.039H95.2172V474.169H141.347V428.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect302",
    d: "M207.346 428.039H161.218V474.169H207.346V428.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect304",
    d: "M273.136 428.039H227.003V474.169H273.136V428.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect306",
    d: "M338.921 428.039H292.789V474.169H338.921V428.039Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect308",
    d: "M404.707 361.013H358.577V407.143H404.707V361.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect310",
    d: "M470.492 361.013H424.365V407.143H470.492V361.013Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect312",
    d: "M404.816 428.037H358.684V474.167H404.816V428.037Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rect314",
    d: "M470.601 428.037H424.469V474.167H470.601V428.037Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg777);
export default __webpack_public_path__ + "static/media/777.8e712658d0574a5d980cf06456d0be78.svg";
export { ForwardRef as ReactComponent };